// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  convertSaleStatusToClassName,
  convertSaleStatusToColor,
} from '../../../../utils/convertSaleStatus';
import { AiOutlineClockCircle } from 'react-icons/ai';

export default function LotteryItem(props) {
  const { data } = props;

  const history = useHistory();

  return (
    <>
      {data && (
        <div className="card-lottery-top card" onClick={() => history.push(`/lottery/${data.id}`)}>
          <div className="card-img-top">
            <img src={data.image} alt={data.name} />
          </div>
          <div className="card-body-pc">
            <div className="card-status">
              <div
                style={{
                  backgroundImage: `url(${convertSaleStatusToClassName(data.sale_status)})`,
                  backgroundSize: '100% 100%',
                }}
                className="sale-status"
              ></div>
              <div className="card-content">
                <div className="card-end-date-icon">
                  <AiOutlineClockCircle />
                </div>
                <div className="AOTFShinMaruGoPro card-end-date">{data.sale_date}</div>
              </div>
            </div>
            <div className="AOTFShinMaruGoPro card-name">{data.name}</div>
          </div>
          <div className="card-body-sp">
            <div className="card-status">
              <div
                style={{
                  backgroundImage: `url(${convertSaleStatusToClassName(data.sale_status)})`,
                  backgroundSize: '100% 100%',
                }}
                className="sale-status"
              ></div>
              <div className="card-name AOTFShinMaruGoPro">{data.name}</div>
            </div>
            <div className="card-end-date AOTFShinMaruGoPro">
              <AiOutlineClockCircle /> {data.sale_date}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
